module.exports = __webpack_public_path__ + "static/media/14UNEP23.5ac3f4e6.jpg";